import {
  CaracteristiqueHotelModel,
  CaracteristiquesTransfert,
  TransfertListModel,
} from "./packageomra.model";

export default class PackageModel {
  constructor() {
    this.id = 0;
    this.name = null;
    this.prices = [];
    this.note = "";
    this.disponibilities = [new DisponibilityVoModel()];
    this.extrats = [new ExtraModel()];
    this.description = "";
    this.caracteristique = new CaracteristiquesPackageVoModel();
    this.destinations = [];
    this.images = [];
    this.imageUrls = [];
    this.programId = 0;
    this.isDisplayed = false;
    this.categoryIds=[]
  }
}

export class ExtraModel {
  constructor() {
    this.id = 0;
    this.providerId = 0;
    this.service = null;
    this.unitCost = 0;
    this.unitFee = 0;
    this.note = "";
    this.exchange = 1;
  }
}

export class PackageCost {
  constructor() {
    this.id = 0;
    this.providerId = null;
    this.cost = null;
    this.exchange = null;
    this.packegePriceId = null;
    this.currencyId = null;
    this.provider = null;
  }
}

export class DestinationVoModel {
  constructor() {
    this.id = 0;
    this.name = "";
    this.order = 0;
    this.nbrDay = 1;
    this.hotelsVo = [new HotelVoModel()];
    this.excursionDestIds = [];
  }
}

export class HotelVoModel {
  constructor(name) {
    this.id = 0;
    this.duration = 1;
    this.checkin = new Date();
    this.exchange = 0;
    this.currencyId = 0;
    this.providerId = 0;
    this.name = name || "";
    this.hotelListId = 0;
    this.destinationId = 0;
    this.packageMealTypes = [];
    this.caracteristique = new CaracteristiqueHotelModel();
  }
}

export class DisponibilityVoModel {
  constructor() {
    this.id = 0;
    this.date = "";
    this.returnDate = "";
    this.onStock = 0;
    this.cost = 0;
    this.commission = 0;
    this.b2BCommission = 0;
    this.airlineId = null;
    this.transfert = new TransfertVo();
    this.flights = [];
  }
}

export class TransfertVo {
  constructor() {
    this.id = 0;
    this.name = "";
    this.description = "";
    this.packageId = 0;
    this.caracteristiqueId = 0;
    this.caracteristiques = new CaracteristiquesTransfert();
    this.transfertLists = [new TransfertListModel()];
  }
}

export class CaracteristiquesPackageVoModel {
  constructor() {
    this.hasVol = false;
    this.hasTransfert = false;
    this.hasHotels = false;
    this.hasVisa = false;
    this.hasMeal = false;
  }
}
